import { Box, Grid, Typography } from "@mui/material";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import KeyValueColumn from "../../common/KeyValueColumn";
import { useCrmConnectorContext } from "./CrmConectorContext";

const CrmSetupInfo = () => {
  const { connectionInfo } = useCrmConnectorContext();
  const { environment, createdBy, createdAt, lastSyncAt, connectedTo } = connectionInfo;

  return (
    <Box sx={{ py: 1 }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Setup
      </Typography>
      <Grid container spacing={5}>
        {environment && (
          <Grid>
            <KeyValueColumn title="Environment" value={environment} />
          </Grid>
        )}
        <Grid>
          <KeyValueColumn title="Created by" value={createdBy || ""} />
        </Grid>
        <Grid>
          <KeyValueColumn title="Created at" value={convertISODateTime(createdAt)} />
        </Grid>
        <Grid>
          <KeyValueColumn title="Last synchronization" value={convertISODateTime(lastSyncAt ?? "")} />
        </Grid>
        <Grid>
          <KeyValueColumn link title="Connected to" value={connectedTo || ""} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CrmSetupInfo;
